import { render, staticRenderFns } from "./SalePunchInfo.vue?vue&type=template&id=252462a7&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./SalePunchInfo.vue?vue&type=script&lang=js&"
export * from "./SalePunchInfo.vue?vue&type=script&lang=js&"
import style0 from "./SalePunchInfo.vue?vue&type=style&index=0&id=252462a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252462a7",
  null
  
)

component.options.__file = "SalePunchInfo.vue"
export default component.exports